<template>
    <div class="country-code-wrap">
        <div class="value-box" @click="onOpen()">
            <span class="value-text">+{{compValue | filterAreaCode}}</span>
            <!-- <img class="value-ico" :style="{ transform: `rotate(${iconRotate})`}" src="../../../../assets/images/icon_arrows_top.png" /> -->
            <div class="value-ico">
                <svg
                    width="100%"
                    viewBox="0 0 12 8"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                    :style="{ transform: `rotate(${iconRotate})` }"
                >
                    <path
                        d="M12 0.264403L6 6L-2.45953e-07 0.264403C0.368789 -0.088135 0.966716 -0.088135 1.33551 0.264403C1.33551 0.264405 1.33551 0.264407 1.33551 0.264409L6 4.72343L10.6645 0.264409C11.0333 -0.0881318 11.6312 -0.0881372 12 0.264397C12 0.264399 12 0.264401 12 0.264403Z"
                        fill="#050B27"
                    />
                </svg>
            </div>
        </div>
        <div class="picker-wrap" v-show="isShow" @click="onClose">
            <div class="picker-center">
                <div class="layer-body">
                    <div v-for="(item, index) of areaCodes" :key="index" class="layer-item" @click="onInput(item.key)">
                        <span>{{item.lable}} +{{item.key}}</span>
                    </div>
                </div>
                <div class="layer-footer">
                    <div class="layer-item" @click="onClose">取消</div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { stopBodyScroll } from '@/util/dom';
import { AREA_CODE } from '@/config/enums';
export default {
    model: {
        prop: 'compValue',
        event: 'input'
    },
    props: {
        compValue: '',
        title: {
            type: String,
            default: '选择区号'
        },
        placeholder: {
            type: String,
            default: '请选择'
        }
    },
    data() {
        return {
            areaCodes: AREA_CODE,
            iconPosition: 'bottom',
            isShow: false
        };
    },
    computed: {
        iconRotate() {
            if (this.iconPosition === 'bottom') {
                return '0';
            }
            return '-180deg';
        }
    },
    mounted() {},
    methods: {
        onInput(v) {
            this.$emit('input', v);
            this.onClose();
        },
        onOpen() {
            setTimeout(() => {
                this.isShow = true;
                stopBodyScroll(true);
            }, 200);
        },
        onClose() {
            this.isShow = false;
            stopBodyScroll(false);
        }
    },
    filters: {
        filterAreaCode(v) {
            return v;
        }
    }
};
</script>

<style lang="less" scoped>
@import '~src/assets/css/variable.less';
.country-code-wrap {
    .value-box {
        width: 58 * @layout375;
        display: flex;
        align-items: center;
        .value-ico {
            width: 12 * @layout375;
            margin-left: 7 * @layout375;
            display: inline-block;
        }
        span {
            color: #040B29;
        }
    }
    .picker-wrap {
        position: fixed;
        z-index: 1000;
        top: 0;
        left: 0;
        bottom: 0;
        width: 100%;
        height: 100%;
        opacity: 1;
        background: rgba(0, 0, 0, 0.75);
        .layer-item {
            padding: 19 * @layout375 20 * @layout375;
            font-size: 16 * @layout375;
            line-height: 22 * @layout375;
            color: #040B29;
            text-align: center;
        }
        .picker-center {
            position: fixed;
            z-index: 1000;
            left: 0;
            width: 100%;
            background-color: #F7F7F8;
            bottom: 0;
            left: 0;
            .layer-body {
                background-color: #fff;
            }
            .layer-footer {
                margin-top: 8 * @layout375;
                background-color: #fff;
                padding-bottom: constant(safe-area-inset-bottom); /* 兼容 iOS < 11.2 */
                padding-bottom: env(safe-area-inset-bottom); /* 兼容 iOS >= 11.2 */
            }
        }
    }
}
</style>


// WEBPACK FOOTER //
// src/marketing_components/form/picker/country-code/index.vue